// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2ZAYV","title":"Header_title__14bXs","left":"Header_left__2jDn4","clinicName":"Header_clinicName__1ku2T"};